import { keepPreviousData, useQuery, useQueryClient } from "@tanstack/react-query";

import { PublicationVersionFile, getRanaApiV1 } from "@nens/rana/api-v1";

import { queryDirectly } from "./hooks/query-directly";

export function getPublicationVersionFilesQuery(
  publicationId: string | undefined,
  version: number | undefined
) {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["publication-version-files", publicationId, version],
    queryFn: async (): Promise<PublicationVersionFile[]> => {
      if (!publicationId || !version) throw new Error("Can't happen.");
      // Note this endpoint has pagination, but we can ignore it: the maximum
      // allowed number of files (100) is equal to the default page length.
      return (
        await getRanaApiV1().PublicationVersionsApi.publicationVersionFilesList({
          publicationId,
          version,
        })
      ).items;
    },
    // version === 0 means newly created publication with no saved versions yet, skip the request
    enabled: !!publicationId && !!version,
    placeholderData: keepPreviousData,
  });
}

export const usePublicationVersionFilesQueryDirectly = () => {
  const queryClient = useQueryClient();
  return async (publicationId: string, version: number) =>
    queryDirectly(queryClient, getPublicationVersionFilesQuery(publicationId, version));
};

export const usePublicationVersionFilesQuery = (
  publicationId: string | undefined,
  version: number | undefined
) => useQuery(getPublicationVersionFilesQuery(publicationId, version));
